import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Dot } from './hud';

const PAGE_LABELS = {
  '/dashboard': 'DASHBOARD',
  '/events': 'EVENT PLANNER',
  '/wallet': 'WALLET',
  '/structures': 'STRUCTURES',
  '/assets': 'ASSETS',
  '/members': 'MEMBERS',
  '/member-stats': 'MEMBER STATS',
  '/logs': 'LOGS',
  '/log-visualizer': 'LOG VISUALIZER'
};

function Topbar({ user }) {
  const [now, setNow] = useState(new Date());
  const location = useLocation();

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  // EVE time is UTC.
  const eveTime = now.toISOString().slice(11, 19);
  const corp = user?.corporationName || 'CORPORATION';
  const pageLabel = PAGE_LABELS[location.pathname] || 'CONSOLE';

  return (
    <header className="topbar">
      <div className="brand">
        <div className="brand-mark" />
        <span>EVEORG</span>
        <span style={{ color: 'var(--text-3)', letterSpacing: '0.2em', marginLeft: 4 }}>// CMD</span>
      </div>

      <div className="crumbs">
        <span>{corp.toUpperCase()}</span>
        <span className="sep">/</span>
        <span className="now">{pageLabel}</span>
      </div>

      <div className="telemetry">
        <span>
          <span className="k">EVE-TIME</span>
          <span className="mono">{eveTime}</span>
        </span>
        <span>
          <span className="k">ESI</span>
          <Dot />
          <span className="mono" style={{ marginLeft: 4 }}>NOMINAL</span>
        </span>
      </div>
    </header>
  );
}

export default Topbar;
